import Ajax from '../utils/Ajax';
import AppDispatcher from '../dispatcher/AppDispatcher';
import PaymentLinkConstants from '../constants/PaymentLinkConstants';
import BookingsConstants from '../constants/BookingsConstants';

export default {
    generatePaymentLink: function (payload) {
        AppDispatcher.handleAction({
            actionType: PaymentLinkConstants.PAYMENT_LINK_LOADING,
            data: {
                booking_id: payload.booking_id,
            },
        });

        Ajax.generatePaymentLink(payload)
            .done((payment_link) => {
                console.log('Got payment link:', payment_link);
                const { token } = payment_link;
                if (!token) {
                    throw new Error('Token not found on response');
                }

                AppDispatcher.handleAction({
                    actionType: BookingsConstants.UPDATE_PAYMENT_LINK,
                    data: {
                        booking_id: payload.booking_id,
                        payment_link,
                    },
                });

                AppDispatcher.handleAction({
                    actionType: PaymentLinkConstants.PAYMENT_LINK_SUCCESS,
                    data: {
                        booking_id: payload.booking_id,
                        payment_link,
                    },
                });
            })
            .fail((err) => {
                console.error('Error while getting payment link:', err);
                AppDispatcher.handleAction({
                    actionType: PaymentLinkConstants.PAYMENT_LINK_FAILED,
                    data: {
                        booking_id: payload.booking_id,
                    },
                });
            });
    },

    successPaymentLink: function (booking_id) {
        AppDispatcher.handleAction({
            actionType: PaymentLinkConstants.PAYMENT_LINK_SUCCESS,
            data: {
                booking_id,
            },
        });
    },

    resetPaymentLink: function (booking_id) {
        AppDispatcher.handleAction({
            actionType: PaymentLinkConstants.PAYMENT_LINK_RESET,
            data: {
                booking_id,
            },
        });
    },
};
